<template>
	<div>
		<h1 class="clearfix mb-4">
			{{ $t('maintenance-mode') }}
			<button @click="save" class="btn btn-primary float-right" :disabled="submitting">{{ $t('save') }}</button>
		</h1>

		<p>{{ $t('maintenance-mode-description') }}</p>

		<YesNoToggle
			:label="$t('enable-maintenance-mode')"
			v-model="enabled"
			class="mb-4"
		/>

		<TextAreaAutosize
			:label="$t('maintenance-message')"
			v-model="message"
			class="mb-4"
		/>

		<UserSelector
			:label="$t('whitelisted-usernames')"
			v-model="selectedUsers"
			:users="users"
			:loading="loadingUsers"
			class="mb-4"
		/>
	</div>
</template>

<script>
import YesNoToggle from "src/components/Inputs/YesNoToggle";
import TextAreaAutosize from "src/components/Inputs/TextAreaAutosize";
import UserSelector from "src/components/Users/UserSelector";

export default {
	components: {
		YesNoToggle,
		TextAreaAutosize,
		UserSelector
	},
	data() {
		return {
			enabled: false,
			message: '',
			whitelistUsernames: [],
			selectedUsers: [],
			users: [],
			loadingUsers: true,
			submitting: false
		};
	},
	mounted() {
		Promise.all([this.fetchSettings(), this.fetchUsers()]).then(() => {
			this.syncSelectedUsers();
		});
	},
	methods: {
		fetchSettings() {
			this.$store.commit('showBlockingSpinner');

			return this.$cfetch(`${this.$settings.APIBaseURL}/maintenancemode/get`)
				.then(res => {
					if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching maintenance mode settings');
					this.enabled = res.result.enabled;
					this.message = res.result.message;
					this.whitelistUsernames = res.result.whitelist;
				})
				.catch(error => {
					this.$log.error.call(this, error);
					this.$store.commit('openDialog', {
						title: this.$t('something-went-wrong'),
						content: this.$t('error-fetching-maintenance-mode')
					});
				})
				.finally(() => {
					this.$store.commit('hideBlockingSpinner');
				});
		},
		fetchUsers() {
			this.loadingUsers = true;

			return this.$cfetch(`${this.$settings.APIBaseURL}/getusers`, {
				method: 'post',
				data: {
					priv: 'ACCESS_APP',
					excludepriv: 'ALL'
				}
			})
				.then(res => {
					if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching users');
					this.users = res.users.map(user => ({
						...user,
						displayname: user.displayName
					}));
				})
				.catch(error => {
					this.$log.error.call(this, error);
					this.$store.commit('openDialog', {
						title: this.$t('something-went-wrong'),
						content: this.$t('error-fetching-maintenance-mode')
					});
				})
				.finally(() => {
					this.loadingUsers = false;
				});
		},
		syncSelectedUsers() {
			this.selectedUsers = this.users.filter(user => this.whitelistUsernames.includes(user.username));
		},
		save() {
			if (this.submitting) return;
			this.submitting = true;

			this.$store.commit('showBlockingSpinner');

			this.$cfetch(`${this.$settings.APIBaseURL}/maintenancemode/save`, {
				method: 'post',
				data: {
					enabled: this.enabled,
					message: this.message,
					whitelist: this.selectedUsers.map(user => user.username)
				}
			})
				.then(res => {
					if (res.status !== 'SUCCESS') throw new Error('Unexpected error saving maintenance mode settings');
					this.$store.commit('openDialog', {
						title: this.$t('success'),
						content: this.$t('saved')
					});
				})
				.catch(error => {
					this.$log.error.call(this, error);
					this.$store.commit('openDialog', {
						title: this.$t('something-went-wrong'),
						content: this.$t('error-saving-maintenance-mode')
					});
				})
				.finally(() => {
					this.$store.commit('hideBlockingSpinner');
					this.submitting = false;
				});
		}
	}
};
</script>
